export enum ReportResponseType {
  IMAGE = 'image',
  PDF = 'pdf',
}
